<div class="p-d-flex p-flex-column p-flex-md-row gap-12">
  <div class="p-label">{{ label }}:</div>
  <span *ngIf="isOk" [ngClass]="'p-tag ' + okIconClass"></span>
  <span *ngIf="!isOk" [ngClass]="'p-tag ' + notOkIconClass"></span>
</div>
